export default __webpack_public_path__ + "static/svg-symbols-074e6f54d45e6d6e4471998ae52bce09.svg";